import { createServerFn } from "@tanstack/react-start";
import { getRequest, setCookie } from "@tanstack/react-start/server";

import { cookieOptions } from "@garimpa/lib/cookieOptions";
import { Cookies } from "@garimpa/lib/cookies";
import { VIEWER_LOCALES, type ViewerLocale } from "@garimpa/lib/viewerPreferences";

export const setLocale = createServerFn({ method: "POST" })
  .validator((value: unknown): ViewerLocale => {
    if (typeof value !== "string" || !(VIEWER_LOCALES as readonly string[]).includes(value)) {
      throw new Error(`Invalid locale: ${String(value)}`);
    }
    return value as ViewerLocale;
  })
  .handler(async ({ data: locale }) => {
    setCookie(
      Cookies.locale.name,
      locale,
      cookieOptions(Cookies.locale, {
        secure: new URL(getRequest().url).protocol === "https:",
      }),
    );
  });
